const Header = () => {
    return (
      <header>
        <div className="hero is-small is-info">
          <div className="hero-body">
            <h1 className="title" style={{fontSize: "150%"}}>ゴルフクラブの種類と役割を知ろう</h1>
          </div>
        </div>
      </header>
    );
  };
  export default Header;